import {
  Button,
  ButtonProps,
  HStack,
  Icon,
  Text,
  IconProps,
  Box,
  VStack,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
interface NavButtonProps extends ButtonProps {
  icon: React.ElementType;
  label: string;
  isSelected?: boolean;
}

export const NavButton = (
  props: NavButtonProps & {
    iconProps?: IconProps;
    route: string;
    subItems?: any[];
    selectedSubItem?: any;
  }
) => {
  const {
    icon,
    label,
    iconProps,
    isSelected,
    route,
    subItems,
    selectedSubItem,
    ...buttonProps
  } = props;
  return (
    <VStack align={"start"}>
      <Link to={route} style={{ textDecoration: "none", width: "100%" }}>
        <Button
          position="relative"
          variant="ghost"
          width="100%"
          justifyContent="start"
          _hover={buttonProps.bg ? { bg: buttonProps.bg } : undefined}
          {...buttonProps}
        >
          <HStack spacing="3">
            <Icon as={icon} boxSize="6" color="subtle" {...iconProps} />
            <Text>{label}</Text>
          </HStack>
          {isSelected && (
            <Box
              position="absolute"
              left="-24px"
              right="0"
              bottom="0"
              top="0"
              width="4.5px"
              height="100%"
              bg="black"
              borderRightRadius="4px"
            />
          )}
        </Button>
      </Link>
      {subItems && isSelected && (
        <VStack align="start" fontSize="sm" spacing="3">
          {subItems.map((item) => (
            <Link
              key={item.route}
              to={item.route}
              style={{ textDecoration: "none" }}
            >
              <HStack spacing="2" paddingLeft="20px">
                {selectedSubItem?.route === item.route ? (
                  <Box
                    width="8px"
                    marginRight={2}
                    height="8px"
                    bg="black"
                    borderRadius="full"
                  />
                ) : (
                  <Box width="8px" marginRight={2} />
                )}
                <Text>{item.label}</Text>
              </HStack>
            </Link>
          ))}
        </VStack>
      )}
    </VStack>
  );
};
